import { CSSProperties } from '@mui/styles';

import { pLabelStyle } from '../styles';

export const agreedTermsStyle: CSSProperties = {
  ...pLabelStyle,
  marginBottom: 0,
  textAlign: 'center',
};
